import React from 'react';

export const SadFaceIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.492 7.707a7.499 7.499 0 11-4.477-6.574M12.027 12.009a4.505 4.505 0 00-8.072 0M12.324 7.005a1.5 1.5 0 00-2.83 0M6.491 7.005a1.501 1.501 0 00-2.83 0"
            stroke="currentColor"
        />
        <path
            d="M15.498 3.836a1.59 1.59 0 01-1.501 1.668 1.59 1.59 0 01-1.501-1.668c0-.922 1.5-3.336 1.5-3.336s1.502 2.414 1.502 3.336z"
            stroke="currentColor"
        />
    </svg>
);
